import { FC } from "react"

import {
  CurrencyValueCell,
  OptionValueToNameCell
} from "../../../../../section"
import If from "../../../../../if"
import SectionCell from "../../../../../section/cell"
import { calcDownPercentage } from "../../../../../../utils"
import { Lead } from "../../../../../../../types"

interface Props {
  data: Lead
  cols: number
}

const LoanScenario: FC<Props> = ({ data, cols }) => {
  const {
    details: {
      loan_type,
      loan_term,
      arm_term,
      loan_amount,
      loan_purpose,
      property_type,
      list_price,
      property_value,
      residency_type,
      credit_score,
      down_payment,
      cash_out,
      household_income,
      va_funding_fee_type
    }
  } = data
  const isRefinance = loan_purpose === "refinance"

  return (
    <div className={`grid grid-cols-${cols} gap-4`}>
      <OptionValueToNameCell label="Loan purpose" value={loan_purpose} />
      <OptionValueToNameCell label="Loan type" value={loan_type} />
      <If
        condition={loan_type === "arm"}
        then={<OptionValueToNameCell label="Arm term" value={arm_term ?? 0} />}
        else={
          <OptionValueToNameCell label="Loan term" value={loan_term ?? 0} />
        }
      />

      <CurrencyValueCell label="Loan amount" value={loan_amount} />

      <If
        condition={loan_purpose === "refinance"}
        then={<CurrencyValueCell label="Cash out" value={cash_out ?? 0} />}
        else={
          <>
            <CurrencyValueCell label="Down payment" value={down_payment ?? 0} />

            <SectionCell
              label="Down percentage"
              value={`${
                down_payment && loan_amount
                  ? calcDownPercentage({
                      list_price,
                      down_payment: parseFloat(down_payment)
                    })
                  : "-"
              }`}
              className="!pt-0"
            />
          </>
        }
      />

      <CurrencyValueCell
        label={isRefinance ? "Property value" : "List price"}
        value={list_price || property_value || 0}
      />

      <If
        condition={!!household_income}
        then={
          <CurrencyValueCell
            label="Household income"
            value={household_income ?? 0}
          />
        }
      />

      <SectionCell
        label="Credit score"
        value={credit_score}
        className="!pt-0"
      />
      <OptionValueToNameCell label="Property type" value={property_type} />
      <OptionValueToNameCell label="Residency type" value={residency_type} />
      <If
        condition={loan_type === "va"}
        then={
          <OptionValueToNameCell
            label="VA Funding Fee"
            value={va_funding_fee_type ?? ""}
          />
        }
      />
    </div>
  )
}

export default LoanScenario
